import React, { Component } from 'react';

class ColumnTitle extends Component {
    constructor(props) {
        super(props);

    }

    ordenarColumna() {
        this.props.orderColumn(this.props.columnName);
    }

    render() {
        const { props } = this;

        return (
            <label className={"atlas_seccionGrilla_normalFontWeight atlas_seccionGrilla__registroCabecera clickable custom" + (props.data.columnaActual === props.columnName ? " atlas_seccionGrilla__registroCabecera--columnaActiva" : "")}>
                <span onClick={this.ordenarColumna.bind(this)}>
                    {props.title}
                    {props.data.columnaActual !== props.columnName ?
                        <i className="seccionGrilla__registroCabeceraTrianguloUp"></i> :
                        !props.data.ascendente && props.icon == false ?
                            <i className="atlas_seccionGrilla__registroCabeceraTrianguloUp atlas_seccionGrilla__registroCabeceraTrianguloUpActivo atlas_seccionGrilla__registroCabeceraTrianguloUp--descendente"></i> :
                            <i className={`atlas_seccionGrilla__registroCabeceraTrianguloUp ${props.data.columnaActual == props.columnName ? "atlas_seccionGrilla__registroCabeceraTrianguloUpActivo" : ""}`}></i>
                    }
                </span>
            </label>
        );
    }
}

export default ColumnTitle;